import { PAYOUT_REQ_RES_LOGS, PAYOUT_REQ_RES_STATUS_CHECK } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const PayoutReqResLogs = (payload) => {
  return apiInstance.post(PAYOUT_REQ_RES_LOGS, payload);
};
export const StatusCheck = (payload) => {
  return apiInstance.post(PAYOUT_REQ_RES_STATUS_CHECK, payload);
};